/**
 * -----------------------------------------------------------------------------
 * Import/Export Page
 * -----------------------------------------------------------------------------
 * This page displays a form for the import/export feature.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import HeaderView from "../../../components/admin/headerView";
import { useTranslation } from "react-i18next";
import ExportScreen from "./exportScreen";
import ImportScreen from "./importScreen";
import ListingPageSubHeader from "../../../components/listingPageSubHeader";
import { AdminFormFieldSubmit } from "../../../components/admin/formFields";
import { routeUrls } from "../../../navigation/routeUrls";
import { APP_CONFIG } from "../../../constants/constants";
import { useLoggedInUserData } from "../../../utils/user";

const ScreenAdminImportExport: React.FC = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "admins.import_export",
  });
  const navigate = useNavigate();
  const thisOrgAssetImageOnMap = useLoggedInUserData("assetimageonmap");

  return (
    <>
      <HeaderView title={t("heading")} />
      <div className={`${APP_CONFIG.DES.DASH.P_HORIZ} pt-4`}>
        <div className="py-4 grid grid-cols-2 gap-4">
          <ExportScreen />
          <ImportScreen />
        </div>
        {thisOrgAssetImageOnMap === "1" && (
          <>
            <hr className="mt-4 mb-8 border-gray-200 border-t-2" />

            {/* Asset Map Icons */}
            <HeaderView wrapperClassName="" title={t("assets.heading")} />

            <ListingPageSubHeader heading={t("assets.description")} />

            <div className="flex flex-col gap-4 py-4">
              <AdminFormFieldSubmit
                type="button"
                variant="secondary"
                label={t("assets.button_standard")}
                onClick={() =>
                  navigate(
                    routeUrls.dashboardChildren.adminChildren.standardIcons
                  )
                }
                buttonDimensionClass="h-10 w-56 px-6"
              />
              <AdminFormFieldSubmit
                type="button"
                variant="secondary"
                label={t("assets.button_custom")}
                onClick={() =>
                  navigate(
                    routeUrls.dashboardChildren.adminChildren.customIcons
                  )
                }
                buttonDimensionClass="h-10 w-56 px-6"
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ScreenAdminImportExport;
